import { render, staticRenderFns } from "./sea-form-group.vue?vue&type=template&id=95cbc8bc&"
import script from "./sea-form-group.vue?vue&type=script&lang=js&"
export * from "./sea-form-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports